import { PropsWithChildren } from 'react'
import { ThemeProvider } from 'styled-components'
import { PartialDeep } from '../types/util'
import merge from 'lodash/merge'
import lightTheme from './light.theme'

export interface UrTheme {
  colors: {
    urGreen: '#37DBD0'
    urBlue: '#0077C0'
    urShadow: '#005594'

    primary: string
    secondary: string
    accent: string
    highlight: string
    placeholder: string

    success: string
    info: string
    warning: string
    error: string

    gray1: string
    gray2: string
    gray3: string
    gray4: string
    gray5: string
    gray6: string
    gray7: string
    gray8: string
    gray9: string

    blueGray: string
    lightBlue: string
    veryLightBlue: string

    border: {
      default: string
    }
    text: {
      dark: string
      light: string
      disabled: string
      gray: string
    }
  }
  sizes: {
    defaultBorderRadius: string
  }
  layout: {
    defaultShadow: string
    defaultBorder: string
  }
  media: {
    mobile: string
    desktop: string
  }
}

export interface UrThemeProviderProps<T extends PartialDeep<UrTheme>>
  extends PropsWithChildren<object> {
  theme?: T
}
export const UrThemeProvider = <T extends PartialDeep<UrTheme>>({
  children,
  theme,
}: UrThemeProviderProps<T>) => {
  const Provider = ThemeProvider as any

  return (
    <Provider
      theme={{
        ...merge(lightTheme, theme ?? {}),
      }}
    >
      {children}
    </Provider>
  )
}
